module.exports = __webpack_public_path__ + "img/jx.97de55af.png";